import React from "react";
import { Link } from "react-router-dom";

function ExperienceHero() {
  const activities = [
    {
      title: "Volleyball",
      image: "/s3/volleyball.jpg",
      className: "activity-card--large",
      link: "/Volleyball",
    },
    {
      title: "Basketball",
      image: "/s3/basketball.jpg",
      className: "activity-card--large",
      link: "/Basketball",
    },
    {
      title: "Flag Football",
      image: "/s3/flag-football.jpg",
      className: "activity-card--large",
      link: "/FlagFootball",
    },
  ];

  const activities2 = [
    {
      title: "LIVE MUSIC",
      image: "/s3/live-music.jpg",
      className: "activity-card--small",
    },
    {
      title: "COMEDY SHOWS",
      image: "/s3/comedy.jpg",
      className: "activity-card--small",
    },
    {
      title: "WRESTLING & MMA",
      image: "/s3/wrestling-mma.jpg",
      className: "activity-card--small",
    },
  ];

  return (
    <section className="experience-hero">
      <div
        id="experienceCarousel"
        className="carousel slide carousel-fade experience-carousel"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner h-100">
          <div className="carousel-item active h-100">
            <img
              src="./s3/concerts_carousel.jpg"
              className="d-block w-100 experience-slide"
              alt=""
            />
          </div>
        </div>
      </div>

      <div className="container-fluid experience-content">
        <header className="experience-heading">
          <span className="futuraPTMedium">Where</span>
          <span className="futuraPTBold">Sports &amp;</span>
          <span className="futuraPTBold">Entertainment</span>
          <span className="futuraPTMedium">Come Together</span>
        </header>

        <div className="activity-grid">
          {activities.map((activity) => (
            <Link
              to={activity.link}
              className={`card activity-card ${activity.className}`}
              key={activity.title}
              style={{
                backgroundImage: `url("${activity.image}")`,
              }}
            >
              <div className="card-body">
                <h2 className="card-title futuraPTBold">
                  {activity.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>

        <div className="activity-grid mt-3">
          {activities2.map((activity) => (
            <Link
              to={activity.link}
              className={`card activity-card-small ${activity.className}`}
              key={activity.title}
              style={{
                backgroundImage: `url("${activity.image}")`,
              }}
            >
              <div className="card-body">
                <h2 className="card-title futuraPTBold">
                  {activity.title}
                </h2>
              </div>
            </Link>
          ))}
        </div>

        <p className="experience-more futuraPTMedium">
          ...and much more
        </p>
      </div>
    </section>
  );
}

export default ExperienceHero;